import { z } from 'zod';

/** Same snapshot shape as customer ViaCEP lookup — platform auth surface. */
export const PlatformLookupZipParamsSchema = z.object({
  zip: z.string().trim().min(8),
});

export type PlatformLookupZipParams = z.infer<typeof PlatformLookupZipParamsSchema>;

export const PlatformLookupZipResponseSchema = z.object({
  zipCodeNormalized: z.string(),
  street: z.string().nullable(),
  neighborhood: z.string().nullable(),
  cityName: z.string(),
  stateCode: z.string(),
  municipalCode: z.string().nullable().optional(),
  ibgeCode: z.string().nullable().optional(),
  stateId: z.uuid().optional(),
  cityId: z.uuid().optional(),
  source: z.literal('viacep'),
  fetchedAt: z.iso.datetime(),
});

export type PlatformLookupZipResponse = z.infer<typeof PlatformLookupZipResponseSchema>;
